/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeAUpRightIcon16Solid = forwardRef('ArrowShapeAUpRightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.465 2H12a2 2 0 0 1 2 2v8.534c0 1.025-1.24 1.538-1.964.814l-1.85-1.85-2.7 2.7a1.75 1.75 0 0 1-2.474 0l-3.21-3.21a1.75 1.75 0 0 1 0-2.475l2.7-2.7-1.85-1.85C1.927 3.24 2.44 2 3.465 2Z" })));
});
